<script setup>
import PreviewSingleImage from "@/components/shared/PreviewSingleImage.vue";


defineProps({
  mediaObject: Array
});

const emit = defineEmits(["deleteMediaObject"]);

function deleteImage(id) {
  console.log("Emit 2do hijo", id);
  emit('deleteMediaObject', id);
}
</script>

<template>
  <div class="d-flex">
    <div v-if="!mediaObject || mediaObject.length==0">
      <PreviewSingleImage />
    </div>
    <div
      v-else
      class="d-flex"
    >
      <PreviewSingleImage
        v-for="media in mediaObject"
        :key="media['hydra:member'] ? media['hydra:member'][0].id : media.id"
        :url="media['hydra:member'] ? media['hydra:member'][0].contentUrl : media.contentUrl"
        :name="media['hydra:member'] ? media['hydra:member'][0].name :media.name"
        @deleteMedia="deleteImage(media['hydra:member'] ? media['hydra:member'][0].id : media.id)"
      />
    </div>
  </div>
</template>
